import { Box, SxProps, Typography } from '@mui/material'

import { HEATMAP_SCALE_COLORS } from '../utils/cooler-detail-formatters'

const HeatmapLegend: React.FC<{ sx?: SxProps }> = ({ sx }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      mb: 1.5,
      px: 0.5,
      ...sx,
    }}
  >
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ whiteSpace: 'nowrap' }}
    >
      $
    </Typography>
    <Box
      sx={{
        flex: 1,
        height: 10,
        borderRadius: 1,
        background: `linear-gradient(to right, ${HEATMAP_SCALE_COLORS.join(', ')})`,
      }}
    />
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ whiteSpace: 'nowrap' }}
    >
      $$$
    </Typography>
  </Box>
)

export default HeatmapLegend
